// extracted by mini-css-extract-plugin
export default {"visible":"Header_visible__pai3X","hidden":"Header_hidden__3-NLV","headerBlock":"Header_headerBlock__qR2qS","header":"Header_header__jioNn","container":"Header_container__CTmXv"};